import React from "react";
import { useState } from "react";
import { Helmet } from 'react-helmet';
import SalespersonSidebar from "./SalespersonSidebar";
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import Loading from './Loading';
import './classes/ManageAgents.css';

const ManageAgents = () => {
   const columns = [   
   {
     field: 'U.username',
     headerName: 'Username',
      headerClassName: 'super-app-theme--header header-link',
    minWidth: 120, 
    flex:1,
          renderCell: (params) => (
     <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
         {params.row.username}
       </Link>
   ),
     
   },
   {
     field: 'U.first_name',
     headerName: 'First Name',
      headerClassName: 'super-app-theme--header header-link',
    minWidth: 100, 
    flex:1,

     
   },
   {
     field: 'U.last_name',
     headerName: 'Last Name',
      headerClassName: 'super-app-theme--header header-link',
    minWidth: 100, 
    flex:1,

     
   },
     {
        field: 'roles',
        headerName: 'Roles',
        headerClassName: 'super-app-theme--header',
        minWidth: 95, 
        flex:1,
         sortable: false,
        filterable: false,  
     },
    {
        field: 'U.status',
        headerName: 'Status',
        headerClassName: 'super-app-theme--header header-link',
        minWidth: 85, 
        flex:1,  
 
     },
           {
        field: 'U.created_at',
        headerName: 'Created At',
        headerClassName: 'super-app-theme--header',
        minWidth: 100, 
        flex:1,     
        sortable: false,
        filterable: false, 
        
      },
       {
        field: 'U.last_login',
        headerName: 'Last access',
        headerClassName: 'super-app-theme--header',
        minWidth: 100, 
        flex:1, 
        sortable: false,
        filterable: false,     
        
      },
            {
        field: 'operations',
        headerName: 'Operations',
        headerClassName: 'super-app-theme--header',
        minWidth: 110, 
        flex:1,     
        sortable: false,
        filterable: false,
        renderCell: (params) => (
        <Link href={params.row.edit_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
            {params.row.linkText || 'Edit'}
        </Link>
        ),
    },
    ]; 
    

    /* Pagination, filter config starts here */
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
      
    const [isLoading, setIsLoading] = useState(true);
    const app_url = configData.APP_URL;
    const [formData, setformData] = useState({
      first_name:'',
      last_name:'',
      name:''
    });

    const [appliedFormData, setAppliedFormData] = useState({
      first_name:'',
      last_name:'',
      name:''
    });
    const handleChange = (event) => {
    const { name, value } = event.target;
    setformData({ ...formData, [name]: value });
    
  };
  React.useEffect(() => {
     const fetchData = async () => {
        // Simulate API call to your server
        // In a real application, replace this with your actual fetch logic
        try {
           setIsLoading(true);
        const response = await fetch(app_url+'smwwagency/getmanageagentlist', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sortModel,
            filterModel,
            // formData:formData
            formData:appliedFormData,
          }),
        });
        const data = await response.json();
        console.log(data.data.rows);
        setRows(data.data.rows);
        setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      }  catch (error) {
              console.error('Error fetching data:', error);
            } finally {
              setIsLoading(false); // Set loading to false after fetch completes (success or error)
            }
      };
  
      fetchData();
     
    }, [paginationModel, sortModel, filterModel,appliedFormData]); // Re-fetch data when these change
  
  
    /* Pagination, filter config ends here */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setPaginationModel({
                 page: 0,
                    pageSize: 50,
                 });
                 setAppliedFormData({ ...formData });
    try {
           setIsLoading(true);
        const response = await fetch(app_url+'smwwagency/getmanageagentlist', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: 0,
            pageSize: 50,
            sortModel,
            filterModel,
            formData:formData
          }),
        });
        const data = await response.json();
        console.log(data.data.rows);
        setRows(data.data.rows);
        setRowCount(data.data.totalRowCount);  // Server should return totalRowCount
    }catch (error) {
              console.error('Error fetching data:', error);
            } finally {
              setIsLoading(false); // Set loading to false after fetch completes (success or error)
            }
  
    
  }; 
   
    return(
       <>
               {isLoading ? (
                    <Loading />
                  ) : (
        <div id="main">
          <Helmet><title>Manage Agents</title></Helmet>
            <div className="left"></div>
            <div className="center left-center">
              <div className="manage-agents-container">  
                <h1>Manage Agents</h1> 
                <div className="manage-agents-filter">
                    <form onSubmit={handleSubmit}>
                      <div className="">
                        {/* First Name */}
                        <div className="manage-agents-filter-items manage-agent-filter-firstname">                                        
                          <label htmlFor="filter-firstname-value">First Name</label>                                        
                          <div className="manage-agent-views-widget manage-agent-form-item">
                              <input
                                type="text"
                                id="filter-firstname-value"
                                name="first_name"
                                size="30"
                                maxLength="128"
                                className="" 
                                onChange={handleChange}
                                value={formData.first_name}
                              />                                           
                          </div>
                        </div>
                        {/* Last Name */}
                        <div className="manage-agents-filter-items manage-agent-filter-lastname">                                        
                          <label htmlFor="filter-lastname-value">Last Name</label>                                        
                          <div className="manage-agent-views-widget manage-agent-form-item">
                            <input
                              type="text"
                              id="filter-Lastname-value"
                              name="last_name"
                              size="30"
                              maxLength="128"
                              className="" 
                              onChange={handleChange}
                              value={formData.last_name}
                            />                                           
                          </div>
                        </div>
                        {/* Username */}
                        <div className="manage-agents-filter-items">                                        
                          <label htmlFor="edit-name">Username</label>                                        
                          <div className="manage-agent-views-widget manage-agent-form-item">
                            <input
                              type="text"
                              id="edit-name"
                              name="name"
                              size="30"
                              maxLength="128"
                              className="" 
                              onChange={handleChange}
                              value={formData.name}
                            />                                           
                          </div>
                        </div>
                        {/* Submit Button */}
                        <div className="manage-agents-submit-button">                                        
                          <button className='form-submit manage-agent-formsubmit' type="submit">Apply</button>
                        </div>
                      </div>
                    </form>
                  </div>                 
                    <div className="manage-agents-table" style={{ width: '100%', overflowX: 'clip',}}>
                      <DataGrid
                        autoHeight
                        rows={rows}
                        columns={columns.map(col => ({ ...col, filterable: false }))} 
                        rowCount={rowCount}
                        disableAutosize
                        getRowHeight={() => 'auto'}
                        paginationMode="server"
                        sortingMode="server"
                        filterMode="server"
                        filterModel={filterModel}
                        onFilterModelChange={setFilterModel}
                        paginationModel={paginationModel}
                        onPaginationModelChange={setPaginationModel}
                        sortModel={sortModel}
                        onSortModelChange={setSortModel}
                        pageSizeOptions={[5, 10, 25, 50]}
                        pageSize={50}
                        getRowId={() => crypto.randomUUID()}                                                                 
                        sx={{
                          fontFamily: '"Open Sans", sans-serif, Arial, Verdana',
                          '& .MuiDataGrid-row': { marginTop: 1, marginBottom: 1 },
                          '& .coloured': { textAlign: 'center', color: '#7181AD' },
                          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': { display: 'block' },
                          '& .super-app-theme--header': { fontSize: '14px' },
                          '.MuiDataGrid-columnHeaderTitle': { fontWeight: 'bold !important',whiteSpace:'normal' },
                          '& .MuiDataGrid-cell': {
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            lineHeight: '1.4',
                            alignItems: 'center',
                            display: 'flex',
                          },
                          '& .MuiTablePagination-actions': { marginRight: 10 },
                          '& .header-link':{color: "#2C99D2"},
                        }}
                        disableColumnResize={true}
                      />
                    </div>
                </div>
            </div>
            <div className="right">
                <SalespersonSidebar/>
            </div>
        </div>
        )}
    </>  
    );
};
export default ManageAgents;